<template>
  <v-container>
    <v-data-table :headers="headers" :items="programas" :loading="loading" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Gestión de Certificaciones Universidades</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <!-- <v-btn color="primary" dark class="mb-2" @click="openDialog()">
            Nuevo Programa
          </v-btn> -->
        </v-toolbar>
      </template>

      <!-- Columna de Acciones (Editar/Eliminar) -->
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>

      <!-- Columna de Estado Activo -->
      <template v-slot:item.is_active="{ item }">
        <v-chip :color="item.is_active ? 'green' : 'red'" dark small>
          {{ item.is_active ? 'Activo' : 'Inactivo' }}
        </v-chip>
      </template>
    </v-data-table>

    <!-- Diálogo para Crear/Editar -->
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field v-model.number="editedItem.program_id" label="ID Programa" type="number"
                  required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model.number="editedItem.universidad_id" label="ID Universidad" type="number"
                  required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model.number="editedItem.precio" label="Precio" type="number" prefix="$"
                  required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="editedItem.moneda" label="Moneda (ej. USD, MXN)" required></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-switch v-model="editedItem.is_active"
                  :label="`Estado: ${editedItem.is_active ? 'Activo' : 'Inactivo'}`"></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Confirmación de Borrado -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">¿Estás seguro de que quieres eliminar este programa?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Cancelar</v-btn>
          <v-btn color="red darken-1" text @click="deleteItemConfirm">Eliminar</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>
<script>
//import xaxios from 'xaxios';
import xaxios from '@/xaxios';
// URL base de tu API de Go. Ajústala si es necesario.
const API_URL = `${process.env.VUE_APP_API_CERTIFICACIONES}/api/v1`;

export default {
  name: 'ProgramaManager',
  data: () => ({
    loading: true,
    programas: [],
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: 'ID', value: 'id', sortable: true },
      { text: 'Programa', value: 'Programa.nombre_compuesto', sortable: true },
      { text: 'Universidad', value: 'Universidad.Nombre', sortable: true },
      { text: 'Precio', value: 'precio' },
      { text: 'Moneda', value: 'moneda' },
      { text: 'Estado', value: 'is_active' },
      { text: 'Acciones', value: 'actions', sortable: false },
    ],
    editedIndex: -1,
    editedItem: {
      id: 0,
      program_id: 0,
      universidad_id: 0,
      precio: 0.0,
      moneda: '',
      is_active: true,
    },
    defaultItem: {
      id: 0,
      program_id: 0,
      universidad_id: 0,
      precio: 0.0,
      moneda: '',
      is_active: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Nuevo Programa' : 'Editar Programa';
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.loading = true;
      try {
        const response = await xaxios.get(`${API_URL}/programas/universidad/certificado`);
        this.programas = response.data || [];
        window.console.log(this.programas)
      } catch (error) {
        window.console.error("Error al obtener los programas:", error);
        alert("No se pudieron cargar los datos.");
      } finally {
        this.loading = false;
      }
    },
    

    openDialog() {
      this.editedIndex = -1;
      this.editedItem = { ...this.defaultItem };
      this.dialog = true;
    },

    editItem(item) {
      this.editedIndex = this.programas.indexOf(item);
      this.editedItem = { ...item };
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.programas.indexOf(item);
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      try {
        await xaxios.delete(`${API_URL}/programas/${this.editedItem.id}`);
        this.initialize(); // Recargar la lista
      } catch (error) {
        window.console.error("Error al eliminar el programa:", error);
        alert("No se pudo eliminar el programa.");
      }
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    async save() {
      try {
        if (this.editedIndex > -1) {
          // Editando un programa existente (PUT)
          await xaxios.put(`${API_URL}/programas/${this.editedItem.id}`, this.editedItem);
        } else {
          // Creando un nuevo programa (POST)
          // La API de Go ignora el 'id' enviado en el body y crea uno nuevo.
          await xaxios.post(`${API_URL}/programas`, this.editedItem);
        }
        this.initialize(); // Recargar la lista
        this.close();
      } catch (error) {
        window.console.error("Error al guardar el programa:", error);
        alert("No se pudo guardar el programa.");
      }
    },
  },
};
</script>

<style>
/* Estilos opcionales */
</style>